import React from "react";
import useClasses from "hooks/useClasses";
import Main from "./CollectableMainData";
import Company from "./CompanyData";

import styles from "./CollectableStyle";
import Contact from "./ContactData";

const CollectableInfo = ({ collectable }) => {
  const classes = useClasses(styles);
  return (
    <div className={classes.container}>
      <div className={classes.mainContainer}>
        <div className={classes.childContainer}>
          <Main collectable={collectable} />
          <Contact collectable={collectable} />
        </div>
        <div className={classes.childContainer}>
          <Company collectable={collectable} />
        </div>
      </div>
    </div>
  );
};

export default CollectableInfo;
